import type { CountryConfig } from "./types";

export const noConfig: CountryConfig = {
  code: "no",
  locale: "nb",
  numberLocale: "nb-NO",
  dateFormat: "dd.MM.yyyy",
  dateFormatRegex: /\d{2}\.\d{2}\.\d{4}/,
  dateSeparator: ".",
  decimalSeparator: ",",
  currency: "NOK",
  hoursPerDay: 7.5,
  hoursPerWeek: 37.5,
  availableLocales: ["nb", "nn"],
  features: {
    salary: false,
    absenceApproval: false,
    sixthWeekDayOff: false,
    messageCenter: false,
    configurableSoCalculation: false,
    employmentEditing: false,
    employmentStatement: false,
    agreementField: false,
    employmentRateAsPercent: true,
    grossTime: false,
    closedDaysInWeekTargetSetting: false,
    poolPlanning: true,
    institutionMasterDataEditing: false,
    endDateConfirmation: true,
    departmentManagement: false,
    personalDataEditing: false,
    departmentMasterDataEditing: false,
    departmentStaffingGraphs: true,
    staffingOverview: true
  },
  terminology: {
    employmentRate: "employmentOverview.rateOfEmploymentPercent",
    appName: "app.nameResourcePlan"
  },
  support: {
    email: "support@ist.no",
    phone: ""
  }
};
